import { TApiButtonCommandFn } from ".";

import { IApiArgument, IButtonAction } from "config";
import modals, { ModalKey } from "containers/Modals/modals";
import { useModal } from "modules";

import { findIndex } from "lodash-es";

import { BREAK_ACTIONS } from "../useButtonAction";

export const useExitFlowWarning = () => {
  const openModal = useModal();

  const getModalFromActionArgs = (actionArgs: IApiArgument[]) => {
    const modalArgument = actionArgs?.find(arg => arg.name === "modal");
    const modalSource = modalArgument?.source;
    const modalExists = modalSource && modals.hasOwnProperty(modalSource);

    return (modalExists ? modalSource : "ExitFlowWarningModal") as ModalKey;
  };

  const exitFlowWarning: TApiButtonCommandFn = (commandArgs, { actions = [] }) => {
    const findCallback = (action: IButtonAction) =>
      action.command.destination === "exitFlowWarning";
    const currentActionIndex = findIndex(actions, findCallback);

    if (currentActionIndex >= 0) {
      const remainingButtonActions = actions.slice(currentActionIndex + 1);

      const modal = getModalFromActionArgs(commandArgs);
      openModal(modal, { actions: remainingButtonActions });
    }

    return BREAK_ACTIONS;
  };

  return exitFlowWarning;
};
